<div class="layout-column custom-panel full-width full-height">

  <div *ngIf="isSelectJobsMode" class="flex layout-column padding-left-10 padding-right-10">
    <div class="layout-row layout-align-start-center padding-top-10 padding-right-10 padding-bottom-5">
      <span class="br-body-1 font-weight-600 primary-100">{{ jobs.length }} {{ 'Calls' | translate }}</span>
      <span class="flex"></span>
      <bringoz-button [type]="'tertiary'"
                      [theme]="'primary'"
                      (onClick)="onClearSelection();$event.stopPropagation();">
        <span class="br-body-4 primary-100">{{ 'Clear Selection' | translate }}</span>
      </bringoz-button>
    </div>

    <div class="layout-column layout-align-start-start gap-5">
      <div class="layout-row layout-align-start-center gap-5" *ngFor="let job of jobs">
        <app-bringoz-checkbox [isChecked]="selectedJobIds.includes(job.id)"
                              (clickEvent)="onSelectJob(job.id)">
        </app-bringoz-checkbox>

        <span class="program-type" [ngClass]="{
          'routed': (visitPlan.scheduleStatus === 'PLANNED' && job.routed),
          'leftover': (visitPlan.scheduleStatus === 'PLANNED' && !job.routed)
        }">
          {{ programTypeAliasMap[job.pricePlanProgramType] }}
        </span>

        <app-task-detailed-service-time *ngIf="job.stops?.[0]?.detailedServiceTime"
                                        class="margin-left-5"
                                        [isAllowEdit]="false"
                                        [detailedServiceTime]="job.stops?.[0]?.detailedServiceTime">
        </app-task-detailed-service-time>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!isSelectJobsMode">
    <!--Search Box-->
    <div class="layout-row layout-align-start-center padding-top-10 padding-left-10 padding-right-10 padding-bottom-5">

      <app-bringoz-search-input class="flex"
                                [placeholder]="ngPlaceholder"
                                [query]="queryString"
                                (queryChangeEvent)="onQueryChange($event)">

      </app-bringoz-search-input>

      <bringoz-switch [checked]="isExternalResourcesMode"
                      [name]="'showAllAgents'"
                      [label]="'Show All Agents' | translate"
                      (onChange)="onToggleIsExternalResourcesMode($event)">
      </bringoz-switch>

    </div>

    <hr class="main-divider">

    <!--BODY-->
    <div class="flex layout-column">

      <div *ngIf="!isExternalResourcesMode" class="flex layout-column padding-left-10 padding-right-10 overflow-auto">

        <div class="layout-row layout-align-start-center option-row" *ngFor="let option of filteredOptions">
          <app-bringoz-radio-button [value]="option.resource.id"
                                    [isSelected]="option.resource.id === selectedResourceId"
                                    (onValueChange)="onSelectResource($event)">
          </app-bringoz-radio-button>

          <div class="flex-30 margin-left-10">
          <span class="br-body-2 font-weight-400"
                style="display: block; overflow: hidden; color: var(--Grey-100, #292929); font-feature-settings: 'liga' off, 'clig' off; text-overflow: ellipsis; white-space: nowrap; font-family: Inter; font-size: 12px; line-height: 18px;">
            {{ option.resource.agentName }}
          </span>
          </div>

          <div class="flex-15">
            <app-bringoz-tags *ngIf="option.resource.agentTags?.length"
                              [tags]="option.resource.agentTags"
                              [maxTags]="1">
            </app-bringoz-tags>
          </div>

          <div class="flex-40">
          <span class="br-caption font-weight-400 gray-102" style="white-space: nowrap;">
            {{ option.resource | timeWindow }}
            <!--            {{ option.resource | bringozTime: 'startTime' }} - {{ option.resource | bringozTime: 'endTime' }}-->
          </span>
          </div>

          <div class="score layout-row layout-align-start-center"
               [ngClass]="{'high': option.score >= 70, 'medium': (option.score < 70 || option.score > 41), 'low': option.score < 40}">
            <span>{{ option.score }}%</span>
          </div>

        </div>


        <!--    <cdk-virtual-scroll-viewport [itemSize]="40" class="flex viewport" (scroll)="getNextBatch()">-->
        <!--      <div *cdkVirtualFor="let resource of resources; let last = last"-->
        <!--           class="layout-row layout-align-start-center item padding-top-5 padding-bottom-5">-->
        <!--        <app-bringoz-radio-button [value]="resource.id"-->
        <!--                                  [isSelected]="resource.id === selectedResourceId"-->
        <!--                                  (onValueChange)="onSelectResource($event)">-->
        <!--        </app-bringoz-radio-button>-->

        <!--        <div class="flex-30 margin-left-10">-->
        <!--          <span class="br-body-2 font-weight-400"-->
        <!--                style="display: block; overflow: hidden; color: var(&#45;&#45;Grey-100, #292929); font-feature-settings: 'liga' off, 'clig' off; text-overflow: ellipsis; white-space: nowrap; font-family: Inter; font-size: 12px; line-height: 18px;">-->
        <!--            {{ resource.agentName }}-->
        <!--          </span>-->
        <!--        </div>-->

        <!--        <div class="flex-20">-->
        <!--          <app-bringoz-tags *ngIf="resource.agentTags?.length"-->
        <!--                            [tags]="resource.agentTags"-->
        <!--                            [maxTags]="1">-->
        <!--          </app-bringoz-tags>-->
        <!--        </div>-->

        <!--        <div class="flex-40 text-right">-->
        <!--          <span class="br-caption font-weight-400 gray-102" style="white-space: nowrap;">-->
        <!--            {{ resource | bringozTime: 'startTime' }} - {{ resource | bringozTime: 'endTime' }}-->
        <!--          </span>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--    </cdk-virtual-scroll-viewport>-->

        <div *ngIf="!isLoading && filteredOptions.length === 0"
             class="br-body-2 font-weight-400 gray-102 text-center margin-top-20">
          {{ 'No resources available' | translate }}
        </div>
      </div>

      <div *ngIf="!!isExternalResourcesMode" class="flex layout-row external-assign-layout">
        <app-visit-plan-external-agents-resource-holders-single-select-list class="flex"
                                                                            [queryString]="queryString"
                                                                            [hideSearch]="true"
                                                                            [visitPlanId]="visitPlan.id"
                                                                            [visitScheduleId]="visitPlan.scheduleId"
                                                                            [selectedAgentId]="externalAssignPayload.agentId"
                                                                            (onSelect)="onSelectExternalResource($event)">
        </app-visit-plan-external-agents-resource-holders-single-select-list>

        <div class="availability-panel flex-40 layout-column" *ngIf="!!externalAssignPayload?.agentId">
          <span class="br-body-2 font-weight-600 primary-100 availability-title" translate>Availability</span>

          <div class="layout-column time-inputs-container margin-bottom-10">
            <app-bringoz-time-select [selectedTime]="externalAssignPayload.startTime"
                                     ticksInMinutes="15"
                                     [min]="dayStartTime"
                                     [max]="externalAssignPayload.endTime"
                                     [placeholder]="'Start Time' | translate"
                                     (onSelect)="onFromTimeChange($event)">
            </app-bringoz-time-select>
          </div>

          <div class="layout-column time-inputs-container">
            <app-bringoz-time-select [selectedTime]="externalAssignPayload.endTime"
                                     ticksInMinutes="15"
                                     [min]="externalAssignPayload.startTime"
                                     [max]="dayEndTime"
                                     [placeholder]="'End Time' | translate"
                                     (onSelect)="onToTimeChange($event)">
            </app-bringoz-time-select>
          </div>

          <div *ngIf="errorMessage" class="layout-row layout-align-start-center margin-top-10">
            <bringoz-icon iconName="error" fill="#f44336"></bringoz-icon>
            <span class="br-body-2 error-text margin-left-5">{{ errorMessage | translate }}</span>
          </div>
        </div>
      </div>

    </div>

  </ng-container>

  <app-bringoz-linear-progress *ngIf="!!isLoading"></app-bringoz-linear-progress>

  <hr class="main-divider" *ngIf="showFooter">

  <div class="layout-row layout-align-start-center padding-5" *ngIf="showFooter">
    <bringoz-button [type]="'tertiary'"
                    [theme]="'primary'"
                    (onClick)="onCancel();$event.stopPropagation();">
      <span>{{ 'Cancel' | translate }}</span>
    </bringoz-button>

    <span class="flex"></span>

    <bringoz-button *ngIf="isSelectJobsMode"
                    [theme]="'secondary'"
                    [isDisabled]="!selectedJobIds.length"
                    (onClick)="onJobIdsSelected();$event.stopPropagation();">
      <span>{{ 'Continue' | translate }}</span>
    </bringoz-button>

    <bringoz-button *ngIf="!isSelectJobsMode"
                    [theme]="'secondary'"
                    [isDisabled]="!selectedResourceId && (!externalAssignPayload?.agentId || !!errorMessage)"
                    (onClick)="onSubmit();$event.stopPropagation();">
      <span>{{ assigning ? ('Assigning...' | translate) : ('Submit' | translate) }}</span>
    </bringoz-button>
  </div>

</div>
